import { vueComponentMixin } from '@tencent/data-schema/lib/vue-ui/definitions';
import { INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
import { getTitleWithParentheses } from "../../../../lib/utils/string";
import Markdown from "../../../../lib/builtin/components/Markdown";
const __script_base__ = {
  name: 'DataSourceMethodSelector',
  mixins: [vueComponentMixin],
  components: {
    Markdown
  },
  inject: {
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  props: {
    // xy手动传入的prop
    targetDataPath: {
      type: String,
      default: undefined
    },
    showMethodMarkdown: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      methodList: []
    };
  },
  methods: {
    getTitleWithParentheses,
    reloadMethodList() {
      var _this$targetDataStub;
      this.methodList = ((_this$targetDataStub = this.targetDataStub) === null || _this$targetDataStub === void 0 ? void 0 : _this$targetDataStub.schema.methods) || [];
    },
    checkRequired(methodSchema) {
      const isRequired = Array.isArray(methodSchema.arguments) && methodSchema.arguments.length && methodSchema.arguments.every(item => item.required !== false);
      return isRequired;
    }
  },
  computed: {
    dataPath() {
      // 从父组件取，太不靠谱了
      return this.targetDataPath || this.container.stub.parent.value.dataPath;
    },
    targetDataStub() {
      var _this$designer;
      if (!this.dataPath) return null;
      return ((_this$designer = this.designer) === null || _this$designer === void 0 || (_this$designer = _this$designer.renderer) === null || _this$designer === void 0 ? void 0 : _this$designer.getStubAtPath(this.dataPath)) || null;
    },
    methodSchema() {
      if (!this.editValue) return null;
      return this.methodList.find(x => x.id === this.editValue);
    },
    methodMarkdown() {
      var _methodSchema$argumen;
      const {
        methodSchema,
        dataPath
      } = this;
      if (!methodSchema || !this.showMethodMarkdown) return '';
      const hasArgs = !!((_methodSchema$argumen = methodSchema.arguments) !== null && _methodSchema$argumen !== void 0 && _methodSchema$argumen.length);
      const ans = [`等价于执行 JavaScript 代码 \`${dataPath}.${methodSchema.id}(${hasArgs ? '__参数__' : ''})\``];
      if (this.checkRequired(methodSchema)) ans.push('**本方法需要传入参数，请注意配置！**');
      return ans.join('\n\n');
    }
  },
  created() {
    this.$watch(() => this.targetDataStub, () => this.reloadMethodList(), {
      immediate: true
    });
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('a-select', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "show-search": "",
      "filter-option": ""
    },
    on: {
      "focus": _vm.reloadMethodList
    },
    model: {
      value: _vm.editValue,
      callback: function ($$v) {
        _vm.editValue = $$v;
      },
      expression: "editValue"
    }
  }, _vm._l(_vm.methodList, function (method) {
    return _c('a-select-option', {
      key: method.id,
      attrs: {
        "value": method.id
      }
    }, [_vm._v("\n\n      " + _vm._s(_vm.getTitleWithParentheses(method.id, method.title)) + "\n\n      "), _vm.checkRequired(method) ? _c('a-tag', [_vm._v("\n        需要传参\n      ")]) : _vm._e()], 1);
  }), 1), _vm._v(" "), _vm.methodMarkdown ? _c('markdown', {
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "source": _vm.methodMarkdown,
      "open-in-new-window": ""
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/flowAtoms/paramsFormComponents/dataSourceMethodSelector.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);